var directionsService = new google.maps.DirectionsService();
var route = null;
var mapCircle = null;
var markers = [];
var listMarkers = [];
var Mapa = {

    initListMap: function() {

        if ($('#listMap').length == 0) return;

        var data = {
            center : {
                lat : $('#listMap').data('lat'),
                lng : $('#listMap').data('lng'),
                zoom : $('#listMap').data('zoom')
            }
        }

        var mapCanvas = document.getElementById('listMap');
        var mapOptions = {
            center: new google.maps.LatLng(data.center.lat, data.center.lng),
            zoom: data.center.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false
        }

        map = new google.maps.Map(mapCanvas, mapOptions);

        for (var i = 0; i < mapMarkers.length; ++i) {
            var image = '/img/ico/map-marker-blue.png';
            var myLatLng = new google.maps.LatLng(mapMarkers[i].lat, mapMarkers[i].lng);

            listMarkers[mapMarkers[i].id] = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: image,
                iconTemp: false
            });
            // Map.bindInfoWindow(map, markers[i], infowindow, contentString, 'blue', markers, infowindows);
        }

        $('.offer-box').hover(function() {
            listMarkers[$(this).data('id')].setAnimation(google.maps.Animation.BOUNCE);
            var latLng = listMarkers[$(this).data('id')].getPosition();
            map.setCenter(latLng);
            listMarkers[$(this).data('id')].setIcon('/img/ico/map-marker-dark_blue.png');
        }, function() {
            listMarkers[$(this).data('id')].setAnimation(null);
            listMarkers[$(this).data('id')].setIcon('/img/ico/map-marker-blue.png')
        });

    },

    initObjectsMap: function () {
        var data = {
            center : {
                lat : 52.5189046,
                lng : 19.1343786,
                zoom : 7
            }
        }

        var mapCanvas = document.getElementById('objects-map');
        var mapOptions = {
            center: new google.maps.LatLng(data.center.lat, data.center.lng),
            zoom: data.center.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false
        }

        var map = new google.maps.Map(mapCanvas, mapOptions);

        var drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.CIRCLE,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['circle']
            },
            circleOptions: {
                fillColor: '#97762c',
                fillOpacity: 0.2,
                strokeWeight: 3,
                strokeColor: '#97762c',
                clickable: true,
                editable: true,
                zIndex: 1
            }
        });

        drawingManager.setMap(map);

        google.maps.event.addListener(drawingManager, 'circlecomplete', function(circle) {
            mapCircle = circle;
            drawingManager.setDrawingMode(null);
        });

        $('#mapSearchButton').click(function() {
            // mapCircle.setMap(null);
            $.each(markers, function( index, value ) {
                value.setMap(null);
            });

            $.get('/map/all', {
                lat : mapCircle.getCenter().lat(),
                lng : mapCircle.getCenter().lng(),
                range : mapCircle.getRadius(),
                venue_type: $('#venueType').val(),
                participants: $('#participants').val(),
                beds: $('#beds').val()
            }, function (response) {
                Mapa.addMakers(map, response.objects);
            }, 'json');

            return false;
        });

        Mapa.initDirectionForm(map);
        // Map.initRouteButtons();

        // this.addMakers(map, data.objects);
        // this.bindDirectionButton();

        return map;
    },

    // initRouteButtons: function () {
    //     $('#obiektymapie-map').on('click', '.big-map-route-button', function() {
    //         console.log('aaaa');
    //     });
    // },

    addMakers: function (map, objects) {

        var infowindows = [];

        for (var i = 0; i < objects.length; ++i) {

            var image = '/img/ico/map-marker-blue.png';
            var myLatLng = new google.maps.LatLng(objects[i].lat, objects[i].lng);

            markers[i] = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: image,
                iconTemp: false
            });

            var contentString = '<div class="obiekt-mapa h-liked">\
                <div class="col-2 obiekt-mapaImg">\
                    <a href="'+objects[i].link+'"><img alt="'+objects[i].name+'" src="'+objects[i].image_url+'"></a>\
                </div>\
                <div class="col-2 obiekt-mapaText">\
                    <h3>' + objects[i].name + '</h3>\
                    <p><a class="colorinherit" href="' + objects[i].link + '">Hotel</a></p>\
                    <p>\
                        '+objects[i].street+'<br>\
                        '+objects[i].post_code+' '+objects[i].city+'\
                    </p>\
                    <p>\
                        '+objects[i].phone+'<br>\
                        <a href="">'+objects[i].email+'</a>\
                    </p>\
                    <div class="clear"></div>\
                    <div class="obiekt-mapaBtn">\
                        <a class="cat-list-btn-2"  href="'+objects[i].link+'">Zobacz</a>\
                        <a data-ga-track="wyjscie-'+objects[i].slug+'-src-'+objects[i].track_source+'" class="cat-list-btn" rel="nofollow" target="_blank" href="'+objects[i].www+'">Strona www</a>\
                    </div>\
                    <div class="clear"></div>\
                </div>\
                <div class="col-1 obiekt-mapaSrch clearfix">\
                    <div class="col-2"><strong>Wyznacz trasę do obiektu</strong></div>\
                    <div class="h-liked-route col-2">\
                        <form class="direction-from" action="#">\
                            <input type="hidden" class="route-lat" value="'+objects[i].lat+'" name="route_lat">\
                            <input type="hidden" class="route-lng" value="'+objects[i].lng+'" name="route_lng">\
                            <div class="input" style="float: left;">\
                                <input type="text" class="direction-address" name="direction_address" value="" placeholder="Ulica, nr lokalu, miasto">\
                            </div>\
                            <div class="button"><button class="cat-list-btn">Wyznacz</button></div>\
                        </form>\
                        <div class="clear"></div>\
                    </div>\
                </div>\
            </div>';

            var infowindow = new google.maps.InfoWindow({
                // maxWidth: 440
            });
            infowindows.push(infowindow);

            Mapa.bindInfoWindow(map, markers[i], infowindow, contentString, 'blue', markers, infowindows);
        }
    },

    bindInfoWindow: function (map, marker, infowindow, contentString, markerico, allmarkers, allinfowindows) {

        google.maps.event.addListener(marker, 'mouseover', function () {
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
            marker.setIcon('/img/ico/map-marker-dark_blue.png')
        });

        google.maps.event.addListener(marker, 'mouseout', function () {

            if (marker.iconTemp == false) {
                marker.setIcon('/img/ico/map-marker-' + markerico + '.png');
                infowindow.close();
            }
        });

        var thisMap = this;

        google.maps.event.addListener(marker, 'click', function () {

            if (marker.iconTemp == false) {

                for (var i = 0; i < allinfowindows.length; ++i) {
                    allinfowindows[i].close();
                    if (allmarkers[i].iconTemp != false) {
                        allmarkers[i].setIcon('/img/ico/map-marker-' + allmarkers[i].iconTemp + '.png');
                    }

                    allmarkers[i].iconTemp = false;
                }

                infowindow.setContent(contentString);
                infowindow.open(map, marker);
                marker.setIcon('/img/ico/map-marker-dark_blue.png');
                marker.iconTemp = markerico;

                selectedLat = marker.getPosition().lat();
                selectedLng = marker.getPosition().lng();

                thisMap.showDirection();
            } else {

                marker.setIcon('/img/ico/map-marker-' + markerico + '.png');
                infowindow.close();
                marker.iconTemp = false;

            }
        });
    },

    initObjectMap : function() {
        var mapCanvas = document.getElementById('location-map');
        if ( ! mapCanvas) return;

        var mapOptions = {
            center: new google.maps.LatLng($('#location-map').data('lat'), $('#location-map').data('lng')),
            zoom: $('#location-map').data('zoom'),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        var map = new google.maps.Map(mapCanvas, mapOptions);

        var image = '/img/ico/map-marker-blue.png';
        var myLatLng = new google.maps.LatLng($('#location-map').data('lat'), $('#location-map').data('lng'));

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: image
        });

        return map;
    },

    initDirectionForm: function(map) {
        $('body').on('submit', '.direction-from', function() {
            $('#mapDirectionAlert').text('');
            var address = $('.direction-address', this).val();
            if (address == '') {
                swal({
                    title: "",
                    text: "Wpisz skąd wyznaczyć trasę.",
                    type: "error",
                    confirmButtonColor: '#97762c'
                });
                return false;
            }

            var lat = $('.route-lat', this).val();
            var lng = $('.route-lng', this).val();

            if (lat == 0 || lng == 0) {
                swal({
                    title: "",
                    text: "Zaznacz obiekt na mapie.",
                    type: "error",
                    confirmButtonColor: '#97762c'
                });
                return false;
            }
            Mapa.showDirection(map, lat, lng, address);
            return false;
        });
    },

    showDirection: function(map, lat, lng, address) {
        var request = {
            origin: address,
            destination: lat + "," + lng,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
        };
        directionsService.route(request, function(result, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                if( route != null ) route.setMap(null) ;
                var polylineOptions = {
                    map: map,
                    strokeColor: "#8f6f28",
                    strokeOpacity: 0.9,
                    strokeWeight: 3,
                    path: result.routes[0].overview_path,
                }
                route = new google.maps.Polyline(polylineOptions);
                map.fitBounds(result.routes[0].bounds);

                swal({
                    title: "Wyznaczono trasę",
                    text: "Dystans: " + result.routes[0].legs[0].distance.text + ' ' + result.routes[0].legs[0].duration.text,
                    type: "success",
                    confirmButtonColor: '#97762c'
                });
            } else {
                swal({
                    title: "Błąd",
                    text: "Nie znaleziono adresu początkowego.",
                    type: "error",
                    confirmButtonColor: '#97762c'
                });
                return false;
            }
        });
    }
};

$(document).ready(function() {

    $(".location-map-init").on("click", function() {
        $(this).fadeOut();
        Mapa.initDirectionForm(Mapa.initObjectMap());
    })
    Mapa.initListMap();

});
